import { graphqlMutation } from './graphqlClient';
import { FORGOT_PASSWORD_MUTATION, LOGIN_MUTATION, RESET_PASSWORD_MUTATION } from '@/graphql/queries/auth';
import { ResetPassword } from '@/types/user';
import { LoginResponse, MutationLoginArgs } from '@/graphql/types';

export const login = async (payload: { email: string, password: string }) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const loginResponse = await graphqlMutation<MutationLoginArgs, { login: LoginResponse }>(
      LOGIN_MUTATION,
      payload,
    );
    return loginResponse.login;
  } catch (error) {
    throw error;
  }
};

export const forgotPassword = async (payload: { email: string, locale: string }) => {
  return await graphqlMutation<{ email: string, locale: string }, { forgotPassword: string }>(
    FORGOT_PASSWORD_MUTATION,
    payload,
  );
};

export const resetPassword = async (payload: ResetPassword) => {
  return await graphqlMutation<ResetPassword, { forgotPassword: string }>(
    RESET_PASSWORD_MUTATION,
    payload,
  );
};
